import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import { Button, Row, Col, Form, Checkbox, message, Input } from 'antd';
import { Button as ButtonMui, TextField, InputAdornment } from "@mui/material"
import Idelete from './../../../../src/assets/pvi-benhhiemngheo/idelete.svg';
import Iedit from './../../../../src/assets/pvi-benhhiemngheo/iedit.svg';
import Iadd from './../../../../src/assets/pvi-benhhiemngheo/iadd.svg';
import MdDone from "./../modalnotification/modaldone";
import MDVAT from "./../modalnotification/modalvat";
import Service from "./../../../extra/getAPI";
import Iticket from "./../../../assets/images/ticket.png";
import Helper from "./../../../extra/helper";
import moment from "moment";

const CreateOrder = (props) => {
  const { listIsu, goStep, ActionList, Back, OpenLink, toltalFees, setToltalFees, feeInsured } = useContext(AuthContext);
  const [vat, setVAT] = useState(null);
  const [isOpen, setisOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rewardAmount, setRewardAmount] = useState(0);
  const [openDone, setOpenDone] = useState(false);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [clickButton, setclickButton] = useState(false);
  const platform = Helper.getParamUrlByKey("platform");
  const showReward = Helper.getParamUrlByKey("reward") === "true";
  const [loading, setLoading] = useState(false);
  const [dataOrder, setDataOrder] = useState({});
  const [commission, setCommission] = useState();
  const [disable, setDisable] = useState(false);

  const formatMoney = (money) => {
    if (money === "" || money === null || money === undefined) return "";
    let str = String(money);
    str = str.replace(/^0+(?=\d)/, "");

    if (!str) return "";

    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const [maxSubsidy, setMaxSubsidy] = useState("");
  const [subsidyValue, setSubsidyValue] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  useEffect(() => {
    // window.scrollTo(0, 0);
    let dataVAT = JSON.parse(localStorage.getItem('vatBHN'))
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    if (dataIsu) {
      setFormData(dataIsu);
    }
    if (dataVAT) {
      setVAT(dataVAT);
    }
    if (showReward) {
      rewardVerify();
    }
  }, [isModalVisible, localStorage.getItem('listInsured')]);

  // useEffect(() => {
  //   const value = Number(
  //     (commission || "").replace(/[.,]/g, "")
  //   );

  //   setMaxSubsidy(value);
  // }, [commission]);


  // useEffect(() => {
  //   dispatch({ type: "onChangeAppliedCommissionAmount", value: subsidyValue ? Number(subsidyValue) : "" });
  // }, [subsidyValue])

  // Lấy hoa hồng
  const rewardVerify = async () => {
    setLoading(true);
    let dataBuyer = JSON.parse(localStorage.getItem('dataIsu'));
    let listInsured = JSON.parse(localStorage.getItem('listInsured'));
    if (listInsured?.length > 0) {
      const mappedArray = listInsured?.map(({ insuredDob, insuredGender }) => ({
        insuredDob: moment(insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        insuredGender: +insuredGender
      }));
      const data = {
        yearsOfInsurance: dataBuyer?.yearsOfInsurance,
        packageId: dataBuyer?.package,
        listOfInsuredPeople: mappedArray
      };
      await Service.apicall(
        "POST",
        `/v1/products/critical-disease/reward/verify`,
        data
      )
        .then((res) => {
          setLoading(false);
          if (res?.data?.success) {
            setDisable(false);
            setRewardAmount(res?.data?.data?.rewardAmount);
            setToltalFees(res?.data?.data?.feesPayment);
          }
        })
        .catch((err) => {
          setLoading(false);
          setDisable(true);
          if (err?.response) {
            message.error(err?.response?.data?.error?.statusCode + ' | ' + 'Tiền thưởng của bạn không đủ để tiếp tục');
          }
        });
    }
  };

  const clearVAT = () => {
    setVAT(null);
    localStorage.removeItem('vatBHN');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const actionFormRule = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        // console.log(values);
        if (listIsu.length > 0) {
          if (isInvalid) {
            return
          }
          createOrder();
        } else {
          message.error({
            content: 'Vui lòng thêm người được bảo hiểm!',
            style: {
              marginTop: '10vh',
            },
          }, 10);
        }
      })
      .catch((err) => {
        if (err?.errorFields?.length > 0) {
          window.scrollTo({
            top: document.body.scrollHeight + 100,
            behavior: "smooth"
          });
        }
      });
  };

  const OpenDone = () => {
    setOpenDone(!openDone);
  }

  const Delete = (index) => {
    if (listIsu) {
      ActionList('delete', +index, '')
      setTimeout(() => {
        if (listIsu.length === 0) {
          let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
          localStorage.setItem('dataIsu',
            JSON.stringify({
              ...dataIsu,
              buyfor: 2
            })
          )
          goStep(5);
        }
      }, 100);
    }
  }

  useEffect(() => {
    if (platform === 'app') {
      getCommission();
    }
  }, [listIsu?.length])

  // Lấy hoa hồng
  const getCommission = async () => {
    setLoading(true);
    let dataBuyer = JSON.parse(localStorage.getItem('dataIsu'));
    let listInsured = JSON.parse(localStorage.getItem('listInsured'));
    if (listInsured?.length > 0) {
      const mappedArray = listInsured?.map(({ insuredDob, insuredGender }) => ({
        insuredDob: moment(insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        insuredGender: +insuredGender
      }));
      const data = {
        productCode: 'bhn',
        pbpCode: 'bhn_pvi',
        yearsOfInsurance: dataBuyer?.yearsOfInsurance,
        packageId: dataBuyer?.package,
        listOfInsuredPeople: mappedArray
      };
      await Service.apicall(
        "POST",
        `/v1/products/critical-disease/commission`,
        data
      )
        .then((res) => {
          setLoading(false);
          if (res?.data?.success) {
            setCommission(res?.data?.data?.commission);
            setMaxSubsidy(res?.data?.data?.subsidyAmount);
            setSubsidyValue("");
          }
        })
        .catch((err) => {
          setLoading(false);
          if (err?.response) {
            message.error(err?.response?.data?.error?.statusCode + ' | ' + "Lấy hoa hồng thất bại.");
          }
        });
    }
  };

  const createOrder = () => {
    setclickButton(true);
    let listInsured = JSON.parse(localStorage.getItem('listInsured'));
    let staff_id = Helper.getParamUrlByKey('staff_id');
    let optional_partner = Helper.getParamUrlByKey('optional_partner');
    let datavat = JSON.parse(localStorage.getItem('vatBHN'));
    let dataBuyer = JSON.parse(localStorage.getItem('dataIsu'));
    let partnerStaffId;
    let optionalPartner;
    let vatInfo
    if (staff_id) {
      partnerStaffId = staff_id
    }
    if (optional_partner) {
      optionalPartner = optional_partner
    }
    if (datavat) {
      vatInfo = datavat
    }
    let dataOrder = {
      platform: platform ? platform : 'web',
      productCode: "bhn",
      providerCode: "PVI",
      pbpId: 96,
      pbpCode: 'bhn_pvi',
      // redeemCode: "REDEEM2025",
      callbackUrl: window.location.href,
      reward: showReward ? 'YES' : 'NO',
      insuranceInfo: {
        buyerName: dataBuyer?.insuredName,
        buyerPhone: dataBuyer?.buyerPhone,
        buyerPrivateId: dataBuyer?.insuredPrivateId,
        buyerDob: moment(dataBuyer?.insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        buyerEmail: dataBuyer?.buyerEmail,
        // buyerAddress: dataBuyer?.buyerAddress || null,
        buyerGender: dataBuyer?.insuredGender,
        validFrom: moment(dataBuyer?.beginDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        yearsOfInsurance: +dataBuyer?.yearsOfInsurance,
        packageId: dataBuyer?.package,
        packageName: "Chương trình" + " " + dataBuyer?.packedIndex,
        partnerStaffId,
        optionalPartner,
        vatInfo,
        affArticleUid: Helper.getParamUrlByKey('aff_article_uid') || undefined
      },
      listOfInsuredPeople: Helper._renderDataIsu(listInsured),
      ...(subsidyValue ? { appliedCommissionAmount: subsidyValue } : {})
    }
    if (dataBuyer?.buyerAddress) {
      dataOrder.insuranceInfo.buyerAddress = dataBuyer?.buyerAddress
    }
    Service.apicall(
      "POST",
      `/v1/products/critical-disease/order`,
      dataOrder
    )
      .then((res) => {
        if (res.data.success) {
          OpenDone();
          setDataOrder(res.data.data);
          setclickButton(false);
        } else {
          message.error("Tạo đơn hàng không thành công vui lòng thử lại!");
          setclickButton(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        setclickButton(false);
        setLoading(false);
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + ' | ' + "Tạo đơn thất bại. Vui lòng thử lại!");
        }
      });
  }

  const css = {
    // input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '0px 0px', padding: 0 },
    iconInput: { width: 20, margin: '14px 10px', position: 'absolute', zIndex: 2 },
    buttonRedeem: {
      cursor: "pointer",
      fontWeight: 600,
      background: "#F58220",
      borderRadius: 8,
      color: "#ffffff",
      textAlign: "center",
      padding: "11px 0px",
    },
    buttonRedeemDisabled: {
      cursor: "pointer",
      fontWeight: 600,
      background: "#808985",
      borderRadius: 8,
      color: "#FFFFFF",
      textAlign: "center",
      padding: "8px 0px",
      border: "1px solid #d9d9d9",
    },
    input: { borderRadius: 8, padding: 10, fontSize: 14, color: "#343A40" },
  }

  return (
    <div style={{ fontSize: 14 }}>
      {
        openDone &&
        <MdDone OpenDone={OpenDone} dataOrder={dataOrder} />
      }
      <MDVAT handleCancel={handleCancel} isModalVisible={isModalVisible} />
      <Row style={{ width: '100%' }}>
        <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontWeight: 600, padding: '2% 3%', width: 500 }}>Thông tin gói bảo hiểm</div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Gói bảo hiểm</div>
          <div style={{ fontWeight: 500, textAlign: 'right' }}>
            Chương trình BH {formData?.packedIndex} - {formData?.listPackageInsu[formData?.packedIndex - 1]?.benefit}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Thời hạn bảo hiểm</div>
          <div style={{ fontWeight: 500, textAlign: 'right' }}>
            {formData?.beginDate + ' - ' + formData?.endDate}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '10px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Số năm bảo hiểm</div>
          <div style={{ fontWeight: 500, textAlign: 'right' }}>
            {formData?.yearsOfInsurance} năm
          </div>
        </Col>
        <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff', }} xs={24}>
          <div style={{ fontWeight: 600, padding: '2% 3%' }}>Thông tin người mua bảo hiểm</div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Họ và tên</div>
          <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {formData?.insuredName}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Ngày sinh</div>
          <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {formData?.insuredDob}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Giới tính</div>
          <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {formData?.insuredGender === 1 ? 'Nam' : 'Nữ'}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Số điện thoại</div>
          <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {formData?.buyerPhone}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '180px' }}>CMND/ CCCD/ Hộ chiếu</div>
          <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {formData?.insuredPrivateId}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '180px' }}>Email</div>
          <div style={{ fontWeight: 500 }}>
            {formData?.buyerEmail}
          </div>
        </Col>
        <Col style={{ padding: '2% 3%', borderBottom: '10px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
          <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Địa chỉ</div>
          <div style={{ fontWeight: 500, textAlign: 'right' }}>
            {formData?.buyerAddress ? formData?.buyerAddress : 'N/A'}
          </div>
        </Col>
        <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff' }} xs={24}>
          <div style={{ fontWeight: 600, padding: '2% 3%' }}>Danh sách người được bảo hiểm</div>
        </Col>
        <div style={{ width: '100%' }}>

        </div>
        {(listIsu || []).map((data, i) => (
          <div key={i} style={{ borderBottom: ((i + 1) === listIsu.length) ? '10px solid #EDEFFA' : '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }} xs={24}>
            <div style={{ padding: '2% 3%', width: '90%' }}>
              <div style={{ fontWeight: 600, textTransform: 'capitalize' }}>{data.insuredName}</div>
              <div style={{ fontSize: 12, color: '#9A9A9A' }}>{Helper._render_quan_he(data.relationshipWithBuyerId)}</div>
            </div>
            <img onClick={() => {
              Delete(i);
              if (data.relationshipWithBuyerId === 1) {
                let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
                localStorage.setItem('dataIsu',
                  JSON.stringify({
                    ...dataIsu,
                    buyfor: 2
                  })
                )
              }
            }} style={{ width: 16, marginRight: '3%' }} src={Idelete} alt="edit icon" />
          </div>
        ))}
        <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff', display: vat ? 'none' : 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
          <div style={{ padding: '2% 3%' }}>
            <div style={{ fontWeight: 600, width: 240 }}>Xuất hóa đơn VAT (không bắt buộc)</div>
          </div>
          <img onClick={showModal} style={{ width: 18, marginRight: '3%' }} src={Iadd} alt="edit icon" />
        </Col>
        <Row style={{ display: vat ? '' : 'none' }}>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #828EE1', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div>
              <span style={{ fontWeight: 600 }}>Thông tin xuất hóa đơn</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img onClick={showModal} style={{ width: 18, marginRight: 15 }} src={Iedit} alt="edit icon" />
              <img onClick={clearVAT} style={{ width: 18 }} src={Idelete} alt="delete icon" />
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '180px' }}>{vat?.typeId === 1 ? 'Tên cá nhân' : 'Tên doanh nghiệp'}</div>
            <div style={{ fontWeight: 500, textAlign: 'right', textTransform: 'capitalize' }}>
              {vat?.name}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Mã số thuế</div>
            <div style={{ fontWeight: 500 }}>
              {vat?.taxCode}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Địa chỉ</div>
            <div style={{ fontWeight: 500, textAlign: 'right' }}>
              {vat?.address}
            </div>
          </Col>
        </Row>

        <Col xs={24}>
          <div style={{ borderTop: '10px solid #EDEFFA', padding: '3% 3% 3% 3%', lineHeight: 2 }}>
            <div style={{ marginBottom: '3%' }}>
              {(!!maxSubsidy && platform === "app") &&
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ fontSize: "14px", marginBottom: "6px" }}>
                    Khoản trợ giá
                  </div>

                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="tel"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    placeholder="Nhập số tiền trợ giá"
                    error={isInvalid || subsidyValue > maxSubsidy}
                    // helperText={isInvalid ? (subsidyValue > maxSubsidy ? `Số tiền vượt quá mức trợ giá tối đa (${formatMoney(maxSubsidy)} VND)` : "Vui lòng nhập số") : ""}
                    value={formatMoney(subsidyValue)}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const onlyNumber = raw.replace(/\D/g, "");
                      if (raw !== "" && onlyNumber === "") {
                        setIsInvalid(true);
                        return;
                      }

                      setIsInvalid(false);
                      setSubsidyValue(Number(onlyNumber));

                      if (onlyNumber > maxSubsidy) {
                        // setIsInvalid(true);
                        setSubsidyValue(maxSubsidy);
                      }
                    }}
                    sx={{

                      background: "white",
                      borderRadius: "10px",
                      "& fieldset": {
                        border: "1px solid #d9d9d9 !important",
                        borderRadius: "10px",
                      },
                      "& .MuiInputBase-root": {
                        padding: "8px 15px",
                        background: "white",
                      },
                      "& .MuiInputBase-input": {
                        padding: "0px",
                        height: "28px",
                        // paddingLeft: "0px",
                        fontSize: "14px",
                      },
                      "& .MuiFormHelperText-root": {
                        background: "none",
                        marginLeft: "0px",
                      },

                      "&.MuiFormControl-root": {
                        background: "none",
                      },
                    }}

                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end"
                          sx={{
                            display: "flex", alignItems: "center",
                            gap: "10px",
                            padding: 1.5,
                            paddingRight: 0
                          }}
                        >

                          <span style={{ fontSize: 13, color: "#6C757D" }}>
                            VNĐ
                          </span>
                          {subsidyValue !== "" &&
                            <span style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSubsidyValue("");
                                setIsInvalid(false);
                              }}>
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.6001 0.600098L0.600098 8.6001M8.6001 8.60009L0.600098 0.600096" stroke="#646D69" stroke-width="1.2" stroke-linecap="round" />
                              </svg>
                            </span>
                          }
                          <ButtonMui
                            size="small"
                            sx={{
                              color: Number(subsidyValue) === maxSubsidy ? "#8e949a" : "#343A40",
                              fontWeight: 550,
                              minWidth: "unset",
                              padding: "6px 8px",
                              background: "#F0F2F5",
                              border: "0.5px solid #D2D2D2",
                              textTransform: "none",
                              gap: "5px",
                              alignItems: "center",
                              display: "flex",
                              borderRadius: "6px",
                              height: 30
                            }}
                            onClick={() => {
                              setSubsidyValue(maxSubsidy);
                              setIsInvalid(false);
                            }}
                            disabled={Number(subsidyValue) === maxSubsidy}
                          >
                            <span style={{ display: "flex", alignItems: "center" }}>
                              <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 4.91667L5.125 0.75M5.125 0.75L9.5 4.91667M5.125 0.75L5.125 10.75" stroke="#FB7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span> Tối đa
                          </ButtonMui>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div
                    style={{
                      fontSize: "12px",
                      color: "#F58220",
                      marginTop: "6px",
                      fontStyle: "italic",
                    }}
                  >
                    Khoản trợ giá tối đa: <span style={{ fontWeight: 600 }}>{formatMoney(maxSubsidy)}</span> VNĐ
                  </div>
                </div>}
              <div style={css.titleInput}>Mã ưu đãi</div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "75%" }}>
                  <Form.Item
                    name="redeem"
                    rules={[
                      {
                        required: false,
                        message: "Vui lòng nhập mã ưu đãi của bạn.",
                      },
                    ]}
                    style={{
                      width: "100%",
                      borderRadius: 8,
                      margin: "0px 0px 5px 0px",
                      padding: 0,
                    }}
                  >
                    <Input
                      autoComplete="off"
                      name="redeem"
                      style={{ ...css.input }}
                      prefix={<img width={18} src={Iticket} alt="quyen loi" />}
                      placeholder="Nhập mã ưu đãi"
                      disabled={true}
                      onChange={(e) => {
                        // onChangForm({
                        //   data: e.target.value,
                        //   name: e.target.name,
                        // });
                        // if (e.target.value) {
                        //   setDataIsu({ ...dataIsu, redeem: e.target.value });
                        // } else {
                        //   setDataIsu({ ...dataIsu, redeem: '', redeemFee: 0 });
                        // }
                        // setUseRedeem(false);
                      }}
                    />
                  </Form.Item>
                </div>
                <div style={{ width: "80px" }}>
                  <div
                    // onClick={() => {
                    //   if (dataIsu?.redeem) {
                    //     verifyDiscount(dataIsu?.redeem);
                    //   }
                    // }}
                    style={
                      // dataIsu?.redeem
                      //   ? css.buttonRedeem
                      //   : css.buttonRedeemDisabled
                      css.buttonRedeemDisabled
                    }
                  >
                    Áp dụng
                  </div>
                </div>
              </div>
              <div
                style={{
                  color: "red",
                  // display: errRedeem ? "" : "none",
                }}
              >
                {/* {errRedeem} */}
              </div>
            </div>
            <div style={{ border: '1px solid #2A3790', padding: '2% 2%', borderRadius: 6, }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontsize: 12, color: '#646D69', width: '150px' }}>Tổng phí bảo hiểm</div>
                <div style={{ fontWeight: 700 }}>
                  {feeInsured} VNĐ
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontsize: 12, color: '#646D69', width: '150px' }}>Ưu đãi</div>
                <div style={{ fontWeight: 700 }}>
                  -0 VNĐ
                </div>
              </div>

              {(!!maxSubsidy && platform === "app") && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ fontsize: 12, color: '#646D69', width: '150px' }}>Trợ giá:</div>
                  <div style={{ fontWeight: 700 }}>{(subsidyValue && !isInvalid) ? formatMoney(subsidyValue) : ''} VNĐ</div>
                </div>
              )}

              {
                showReward &&
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ fontsize: 12, color: '#646D69', width: '150px' }}>Áp dụng tiền thưởng</div>
                  <div style={{ fontWeight: 700 }}>
                    -{rewardAmount || 0} VNĐ
                  </div>
                </div>
              }
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontSize: 15, color: '#383D3B', width: '160px' }}><b>Tổng tiền thanh toán</b></div>
                <div style={{ fontWeight: 700, color: '#2A3790', fontSize: 15 }}>
                  <b>{formatMoney(Number(toltalFees.replace(/[.,]/g, "")) - (isInvalid ? 0 : subsidyValue))} VNĐ</b>
                </div>
              </div>
            </div>
          </div>
          {
            (platform === "app" && !showReward) &&
            <div style={{ padding: '0px 3% 3% 3%' }}>
              <div style={{ border: '1px solid #FB7800', padding: '2% 2%', borderRadius: 6, background: '#EAEAEA' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ fontSize: 15, color: '#383D3B', width: '150px' }}><b>Lương doanh thu:</b></div>
                  <div style={{ fontWeight: 700, color: '#FB7800', fontSize: 15 }}>
                    {formatMoney(Number(commission?.replace(/[.,]/g, "")) - (isInvalid ? 0 : subsidyValue))} VNĐ
                  </div>
                </div>
              </div>
            </div>
          }
        </Col>

        <Form
          ref={formRef}
          form={form}
          onFinish={actionFormRule}
          name="rule"
        >
          <Col style={{ background: '#EDEFFA' }} xs={24}>
            <div style={{ padding: '10px 3% 0px 3%' }}>
              <Form.Item
                name="rules"
                rules={[{
                  required: true,
                  message: 'Vui lòng đồng ý điều kiện, điều khoản.'
                }]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group disabled={isOpen} style={{ width: '100%' }}>
                  <Checkbox value="rules">
                    <div style={{ color: '#646D69', fontWeight: 400 }}>
                      Tôi cam kết những nội dung trên là đúng sự thật và tôi đã đọc hiểu,
                      đồng ý với <span onClick={() => OpenLink("https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/QTBH_benh_hiem_ngheo_9_2018.pdf")} style={{ color: '#2A3790', textDecoration: 'underline' }}>điều kiện, điều khoản</span> của hợp đồng bảo hiểm.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div style={{ padding: '10px 3% 0px 3%' }}>
              <Form.Item
                name="rules2"
                rules={[{
                  required: true,
                  message: 'Vui lòng đồng ý điều kiện, điều khoản.'
                }]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group disabled={isOpen} style={{ width: '100%' }}>
                  <Checkbox value="rules">
                    <div style={{ color: '#646D69', fontWeight: 400 }}>
                      Tôi đồng ý với <span onClick={() => OpenLink("https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-05-06-Chinh-sach-bao-mat-du-lieu-ca-nhan.pdf")} style={{ color: '#2A3790', textDecoration: 'underline' }}>“Chính sách thu thập, xử lý dữ liệu cá nhân”</span>.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div style={{ padding: '10px 3% 0px 3%' }}>
              <Form.Item
                name="rules3"
                rules={[{
                  required: true,
                  message: 'Vui lòng đồng ý chính sách.'
                }]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group disabled={isOpen} style={{ width: '100%' }}>
                  <Checkbox value="rules">
                    <div style={{ color: '#646D69', fontWeight: 400 }}>
                      Tôi đồng ý với <span onClick={() => OpenLink("https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-GC-CHINH-SACH-PHONG-CHONG-GIAN-LAN-THAM-NHUNG.pdf")} style={{ color: '#2A3790', textDecoration: 'underline' }}>"Chính sách phòng chống gian lận và tham nhũng"</span>.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div style={{ padding: '10px 3% 0px 3%' }}>
              <Form.Item
                name="rules4"
                rules={[{
                  required: true,
                  message: 'Vui lòng đồng ý chính sách.'
                }]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group disabled={isOpen} style={{ width: '100%' }}>
                  <Checkbox value="rules">
                    <div style={{ color: '#646D69', fontWeight: 400 }}>
                      Tôi đồng ý với <span onClick={() => OpenLink("https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/Quy_Dinh_Bao_Ve_DLCN_10_2023.pdf")} style={{ color: '#2A3790', textDecoration: 'underline' }}>"Chính sách bảo vệ dữ liệu cá nhân"</span> của Tổng công ty Bảo hiểm PVI.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div style={{ color: '#BF272D', padding: '10px 3% 40px 3%', marginBottom: 110 }}>
              Lưu ý: Khi chọn vào mục này, đồng nghĩa việc kê khai bảo hiểm đã xong và quý khách không thể cập nhật lại.
            </div>
          </Col>
        </Form>
        <Col xs={24}>
          <div style={{ borderRadius: '16px 16px 0px 0px', justifyContent: 'center', padding: '16px 18px 20px 18px', boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)', width: '100%', background: '#ffffff', position: 'fixed', bottom: 0, maxWidth: 800 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <div>Tổng tiền thanh toán</div>
              <div>
                <span style={{ fontWeight: 700, color: '#2A3790', fontSize: 18 }}>{formatMoney(Number(toltalFees.replace(/[.,]/g, "")) - (isInvalid ? 0 : subsidyValue))}</span><span style={{ color: '#9A9A9A', fontSize: 14 }}> VNĐ</span>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={() => { Back() }} size="large" style={{ fontSize: 14, background: '#fff', color: '#2A3790', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Quay lại
              </Button>
              <Button
                loading={clickButton || loading}
                disabled={clickButton || loading || disable}
                onClick={() => { actionFormRule() }} size="large" style={{ fontSize: 14, background: '#2A3790', color: '#ffffff', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Tiếp tục
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div >
  );
};

export default CreateOrder;
